import { CardStatus, type HelcimCard } from '@kalos/kalos-rpc';

export function pickDisplayCard(
  cards: HelcimCard[],
  preferredToken?: string,
): HelcimCard | undefined {
  if (!cards?.length) return undefined;
  if (preferredToken?.trim()) {
    const preferred = cards.find((c) => c.tokenId.trim() === preferredToken.trim());
    if (preferred) return preferred;
  }
  const active =
    cards.find((c) => c.status === CardStatus.ACTIVE) ??
    cards.find((c) => c.status === CardStatus.EXPIRING_SOON);
  if (active) return active;
  return cards[0];
}

export function cardStatusLabel(status: CardStatus): string {
  switch (status) {
    case CardStatus.ACTIVE:
      return 'Active';
    case CardStatus.EXPIRING_SOON:
      return 'Expiring soon';
    case CardStatus.EXPIRED:
      return 'Expired';
    default:
      return 'Unknown';
  }
}

export function formatBrandLabel(brand: string): string {
  const b = brand.trim().toLowerCase();
  if (!b || b === 'unknown') return 'Card';
  return b.charAt(0).toUpperCase() + b.slice(1);
}
